import { Button } from '@mui/material'
import type React from 'react'
import { useAuth } from '../hooks/useAuth'

type SaveButtonProps = {
  title: string
  isButtonDisabled: boolean
  onClick: () => void
}

export const SaveButton: React.FC<SaveButtonProps> = props => {
  const auth = useAuth()
  return (
    <>
      <Button
        disabled={props.isButtonDisabled || auth.isDisable}
        onClick={props.onClick}
        sx={{
          justifyContent: 'center',
          font: 'normal normal bold 21px/29px Noto Sans JP',
          textAlign: 'center',
          color: props.isButtonDisabled ? '#CACACA' : '#FFFFFF',
          background: props.isButtonDisabled ? '#F4F4F4 0% 0% no-repeat padding-box' : '#282828',
          '&:hover': {
            color: '#FFFFFF',
            backgroundColor: '#282828',
            opacity: 0.8,
          },
          boxShadow: '0px 2px 2px #00000014',
          height: '49px',
          width: '189px',
          borderRadius: '10px',
          alignItems: 'center',
        }}
      >
        {props.title}
      </Button>
    </>
  )
}
